module.exports = __webpack_public_path__ + "assets/icons/ic_search_24px.svg";